import {
  Box,
  Button,
  Divider,
  HStack,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react";
import { AdminTicketType } from "@common/interfaces/KYDTicket";
import { useState } from "react";
import { getRandomString } from "../utils";

const CodeSection = ({
  updateDirtyText,
  ticketType,
  isLoading,
  dirtyText,
  isTieredTicketType = false,
  error = "",
}: {
  updateDirtyText: (update: object) => void;
  isLoading: boolean;
  ticketType?: AdminTicketType;
  dirtyText: Record<string, any>;
  isTieredTicketType?: boolean;
  error?: string;
}) => {
  const [isOpen, setIsOpen] = useState(!!ticketType?.code);
  const ticketTypeIdOrCreate =
    ticketType && !isTieredTicketType ? ticketType.id : "tickettype";

  const getValueForField = (field: string) => {
    return `${ticketTypeIdOrCreate}.${field}` in dirtyText &&
      dirtyText[`${ticketTypeIdOrCreate}.${field}`] !== "_DELETE_"
      ? dirtyText[`${ticketTypeIdOrCreate}.${field}`]
      : ticketType && ticketType[field]
      ? ticketType[field]
      : null;
  };

  return (
    <Stack spacing={2} my={2}>
      <Stack>
        <Heading size="md">Settings</Heading>
        <Divider />
      </Stack>
      <HStack w="full">
        <Switch
          colorScheme="green"
          defaultChecked={isOpen}
          isDisabled={ticketType?.code === "boxoffice"}
          onChange={() => {
            const changingTo = !isOpen;
            setIsOpen(changingTo);

            if (changingTo === false) {
              updateDirtyText({ [`${ticketTypeIdOrCreate}.code`]: "_DELETE_" });
            }
          }}
          ml={2}
        />
        <Text fontWeight={"medium"}>Require code to unlock ticket type</Text>
      </HStack>

      {isOpen ? (
        <VStack>
          <InputGroup size={"md"}>
            <Input
              pr="6rem"
              isDisabled={isLoading}
              onChange={(e) => {
                updateDirtyText({
                  [`${ticketTypeIdOrCreate}.code`]: e.target.value,
                });
              }}
              isInvalid={!!error}
              value={getValueForField("code")}
              placeholder="Enter code"
            />
            {!ticketType?.code || ticketType?.code === "_DELETE_" ? (
              <InputRightElement width="6rem">
                <Button
                  onClick={() => {
                    const s = getRandomString(10).toUpperCase();
                    updateDirtyText({ [`${ticketTypeIdOrCreate}.code`]: s });
                  }}
                  h="1.75rem"
                  size="sm"
                >
                  Generate
                </Button>
              </InputRightElement>
            ) : null}
          </InputGroup>
          <Box h={4} width={"full"}>
            {error ? (
              <Text align={"left"} fontSize={"sm"} color="red.300">
                {error}
              </Text>
            ) : null}
          </Box>
        </VStack>
      ) : null}
    </Stack>
  );
};

export default CodeSection;
